import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'

// UI

import { Box, Button, Flex, Heading, Spacer } from '@chakra-ui/react'

//Hooks
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//helper

import { useInitialTableState } from '@/components/Table/components/useInitialTableState'
import FullTable from '@/components/Table/FullTable/FullTable'
import { convertTableStateToQuery } from '@/utils/tableHelper'
import { createColumnHelper } from '@tanstack/react-table'
import { toast } from 'react-toastify'
import useTableProfile from '@/features/tableProfiles/useTableProfile'
import getTableProfileListColumns from '@/features/tableProfiles/constants/tableProfileListColumns'
import { LoadingSection } from '@/components/Elements'

const TableProfileListPage = () => {
  //State

  const [storedTableState, setStoredTableState] = useInitialTableState(`table_state:tableprofile`, {})
  const query = convertTableStateToQuery(storedTableState)

  // Hooks

  const { useFetchAllTableProfiles, useToggleActiveTableProfile, useAddProfileToAllUsers } = useTableProfile()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const columnHelper = createColumnHelper()
  const toggleActiveTableProfile = useToggleActiveTableProfile()
  const addProfileToAllUsers = useAddProfileToAllUsers()

  //Fetch
  const { data: tableProfileResponse, isLoading } = useFetchAllTableProfiles({
    ...query,
    filters: {
      ...query.filters,
      isCreatedFromAdmin: 'yes',
    },
  })

  // Handler

  const handleToggle = useCallback(
    async (id) => {
      try {
        dispatch(showLoadingOverlay())
        await toggleActiveTableProfile.mutateAsync(id)
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoadingOverlay())
      }
    },
    [dispatch]
  )

  const handleAddProfileToAllUsers = async (id) => {
    try {
      dispatch(showLoadingOverlay())
      await addProfileToAllUsers.mutateAsync(id)
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  const handleCreateTableprofile = () => {
    navigate('create')
  }

  const defaultColumns = getTableProfileListColumns({
    handleToggle,
    handleAddProfileToAllUsers,
  })

  if (isLoading) {
    return <LoadingSection />
  }
  const handleRowClick = (row) => {
    console.log(row)
    if (!row?.original?._id) {
      toast.error('Missing Profile Id')
      return
    }

    navigate(row?.original?._id)
  }

  return (
    <>
      <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
        <Flex p={5} borderBottom="1px solid #d8dbe0">
          <Heading>Table Profiles</Heading>
          <Spacer></Spacer>
          <Button colorScheme="green" onClick={handleCreateTableprofile}>
            Create
          </Button>
        </Flex>
        <Box p={5} overflow="scroll">
          <FullTable
            data={tableProfileResponse?.data?.results ? tableProfileResponse?.data?.results : []}
            rowCount={tableProfileResponse?.data?.count || 0}
            columnDef={defaultColumns}
            state={storedTableState}
            setState={setStoredTableState}
            handleRowClick={handleRowClick}
          />
        </Box>
      </Box>
    </>
  )
}

export default TableProfileListPage
